const TRUST_COPY = {
  fr: {
    expert: 'LPB Expert',
    trusted: 'Très fiable',
    verified: 'Profil vérifié',
    progressing: 'En progression',
    new: 'Nouveau sur LPB',
    excellent: 'Excellent',
    veryGood: 'Très bon',
    good: 'Bon',
    developing: 'À développer',
    scoreNew: 'Nouveau',
  },
  en: {
    expert: 'LPB Expert',
    trusted: 'Highly reliable',
    verified: 'Verified profile',
    progressing: 'Building history',
    new: 'New to LPB',
    excellent: 'Excellent',
    veryGood: 'Very good',
    good: 'Good',
    developing: 'Developing',
    scoreNew: 'New',
  },
};

export const trustLevel = (score = 0, verifiedProjects = 0, language = 'fr') => {
  const copy = TRUST_COPY[language === 'en' ? 'en' : 'fr'];
  const value = Number(score) || 0;
  const projects = Number(verifiedProjects) || 0;
  if (projects >= 30 && value >= 90) return { label: copy.expert, tone: 'expert' };
  if (projects >= 10 && value >= 80) return { label: copy.trusted, tone: 'trusted' };
  if (projects >= 3 && value >= 65) return { label: copy.verified, tone: 'verified' };
  return { label: projects > 0 ? copy.progressing : copy.new, tone: 'new' };
};

export const scoreLabel = (score, language = 'fr') => {
  const copy = TRUST_COPY[language === 'en' ? 'en' : 'fr'];
  const value = Number(score) || 0;
  if (value >= 90) return copy.excellent;
  if (value >= 80) return copy.veryGood;
  if (value >= 65) return copy.good;
  if (value > 0) return copy.developing;
  return copy.scoreNew;
};

export const percentage = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  return Number.isFinite(number) ? `${Math.round(number * 100)}%` : '—';
};
